import { createContext } from 'react';
import type { Snackbar, SnackbarBase } from './SnackbarProvider';

export interface SnackbarContext {
  snackbars: Snackbar[];
  removeSnackbar: (id: number) => void;
  updateSnackbar: (id: number, snackbar: SnackbarBase) => void;
  pushSnackbar: (snackbar: SnackbarBase) => number;
  pushSnackbarInfo: (reactNode: React.ReactNode | string, infinite?: boolean) => number;
  pushSnackbarSuccess: (reactNode: React.ReactNode | string) => number;
  pushSnackbarWarning: (reactNode: React.ReactNode | string) => number;
  pushSnackbarError: (reactNode: React.ReactNode | string) => number;
}

export const SnackbarContext = createContext<SnackbarContext | undefined>(undefined);
